export default "__VITE_ASSET__a4ca256b__"